import { Box, Progress, Text } from "@chakra-ui/react";
import { FC } from "react";

import { ColumnDefinition, RanaTable } from "@nens/ranalib";
import { ThreediModelTask } from "@nens/threedi/openapi-client";

interface TasksTableProps {
  tasks: ThreediModelTask[];
}

type TaskWithUuid = ThreediModelTask & { uuid: string };

const TaskProgressBar: FC<{ task: TaskWithUuid }> = ({ task }) => {
  const progressPct = ((task.detail as unknown as any).progress || 0) * 100;
  console.log("Task detail:", task.detail, "Progress:", (task.detail as unknown as any)?.progress);

  const colorScheme =
    task.status === "revoked" || task.status === "failure"
      ? "red"
      : task.status === "success"
      ? "green"
      : "blue";
  const inprogress = task.status === "started";

  return (
    <Progress
      height="1rem"
      colorScheme={colorScheme}
      value={progressPct}
      hasStripe={inprogress}
      isIndeterminate={inprogress && progressPct === 0}
    />
  );
};

const TasksTable: FC<TasksTableProps> = ({ tasks }) => {
  const tasksWithUuid: TaskWithUuid[] = tasks.map((task) => {
    return { ...task, uuid: "" + task.id };
  });

  const columnDefinitions: ColumnDefinition[] = [
    {
      title: "Task Name",
      width: "table_cell_xs",
    },
    {
      title: "Status",
      width: "table_cell_xxs",
    },
    {
      title: "Progress",
      width: "table_cell_l",
    },
    {
      title: "Message",
      width: "table_cell",
    },
  ];

  return (
    <RanaTable
      columnDefinitions={columnDefinitions}
      tableDataIds={tasksWithUuid.map((task) => task.uuid)}
      isLoading={false}
      emptyElement={<RanaTable.Empty>No updates to see</RanaTable.Empty>}
      sx={{
        // vertical alignment for the icons and checkboxes
        "& p": {
          marginBottom: 0,
        },
        "& label": {
          marginBottom: 0,
        },
      }}
    >
      <RanaTable.Container>
        <RanaTable.Header />
        <RanaTable.Body>
          {tasksWithUuid.map((task, index) => (
            <RanaTable.Row key={`${task.uuid}${index}`} rowId={task.uuid}>
              <RanaTable.Cell>
                <Text>{task.name}</Text>
              </RanaTable.Cell>
              <RanaTable.Cell>
                <Text>{task.status}</Text>
              </RanaTable.Cell>
              <RanaTable.Cell>
                <Box width="100%">
                  <TaskProgressBar task={task} />
                </Box>
              </RanaTable.Cell>
              <RanaTable.Cell>
                <Text>{(task.detail as unknown as any).message || ""}</Text>
              </RanaTable.Cell>
            </RanaTable.Row>
          ))}
        </RanaTable.Body>
      </RanaTable.Container>
    </RanaTable>
  );
};

export default TasksTable;
